const PERSONAL_FILTER_FORM_INITIAL_VALUES = {
  loanAmount: 15000,
  creditScoreApprox: 749,
}
const STUDENT_LOAN_REFI_FILTER_FORM_INITIAL_VALUES = {
  loanAmount: 60000,
  creditScoreApprox: 749,
}
const DEFAULT_ACTIVE_TAB = 'top-rates'

const YOUNG_ALFRED_STORAGE_KEY = 'young_alfred'

const INSURANCE_FORM_INITIAL_VALUES_FIELDS = [
  'city',
  'country',
  'policyType',
  'state',
  'streetAddress',
  'unit',
  'zipCode',
  'emailAddress',
  'firstName',
  'lastName',
]
const FOX_THEME = 'fox'
const WSJ_THEME = 'wsj'
// @cred/react-theme 5.x renamed the current WSJ styles to 'wsj-old'; 'wsj' is the unadopted re-theme
const WSJ_OLD_THEME = 'wsj-old'
const NYPOST_THEME = 'nypost'
const FOX1_THEME = 'fox1'
const FORBES1_THEME = 'forbes1'
const INSIDER_THEME = 'insider'
const FOX_THEME_VALUES = [FOX_THEME, FOX1_THEME]
const ADVERTISER_DISCLOSURE_THEMES = [...FOX_THEME_VALUES]

const DEFAULT_ADVERTISER_DISCLOSURE = 'partners-widgets.advertiser-disclaimer.default'

export {
  PERSONAL_FILTER_FORM_INITIAL_VALUES,
  STUDENT_LOAN_REFI_FILTER_FORM_INITIAL_VALUES,
  DEFAULT_ACTIVE_TAB,
  YOUNG_ALFRED_STORAGE_KEY,
  INSURANCE_FORM_INITIAL_VALUES_FIELDS,
  ADVERTISER_DISCLOSURE_THEMES,
  FOX_THEME_VALUES,
  DEFAULT_ADVERTISER_DISCLOSURE,
  WSJ_THEME,
  WSJ_OLD_THEME,
  NYPOST_THEME,
  FOX_THEME,
  FOX1_THEME,
  FORBES1_THEME,
  INSIDER_THEME,
}
